package nl.volleyplanner.web.base

// TODO: Move to relevant package (this file used to contain deprecated PageContext as well)
data class PageMeta(
    val title: String,
    val url: String
)
